var _rect, _mask, _rect2, _line, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconInput(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 2,
    fill: "#EFF0F4"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_334_11",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 10,
    width: 17,
    height: 7,
    rx: 1
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 10,
    width: 17,
    height: 7,
    rx: 1,
    stroke: "#292D32",
    strokeWidth: 2.3,
    mask: "url(#path-2-inside-1_334_11)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 13.575,
    y1: 13.425,
    x2: 20.425,
    y2: 13.425,
    stroke: "#292D32",
    strokeWidth: 1.15,
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 13.65L9.525 14.175L11.1 12.6",
    stroke: "#292D32",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInput);
export default __webpack_public_path__ + "static/media/iconInput.0a0de013.svg";
export { ForwardRef as ReactComponent };